const React = require('react');
const css = require('./module.scss');

class Panel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            panelState: this.props.isOpen
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            panelState: nextProps.isOpen
        });
    }

    changePanel(e) {
        this.setState({
            panelState: !this.state.panelState
        });
    }

    render() {
        let cls = ['fp-panel-item'];
        let headerCls = ['fp-panel-header'];
        let panelCls = ['fp-panel-content'];

        if (this.props.headerClass) {
            headerCls.push(this.props.headerClass);
        }
        if (this.props.panelClass) {
            panelCls.push(this.props.panelClass);
        }

        if (this.state.panelState) {
            headerCls.push('fp-header-active');
            panelCls.push('fp-panel-active');
        } else {
            headerCls.push('fp-header-inactive');
            panelCls.push('fp-panel-inactive');
        }

        return <div className={cls.join(' ')}>
            <div className={headerCls.join(' ')} onClick={this.changePanel.bind(this)}>
                {
                    this.props.operations ? this.props.operations : null
                }
                {this.props.children ? <i></i> : null}
                {this.props.header}
            </div>
            <div className={panelCls.join(' ')}>
                {
                    this.props.children ? 
                        <div className="fp-panel-content-box">
                            {this.props.children}
                        </div>
                        : null
                }
                
            </div>
        </div>;
    }
}

module.exports = Panel;


// WEBPACK FOOTER //
// ./component/collapse/panel.js